import { showConfirmModal } from 'logic/modals/confirm-modal/confirm-modal';
import { translate, translationKeys } from 'logic/translations/translations.service';
import React from 'react';

interface DialogResultHandlers {
  onDialogResponseCancel?: () => void;
  onDialogResponseOK?: () => void;
}

export const handleCancelSubscriptionDialog = (dialogResultHandlers: DialogResultHandlers) => {
  showConfirmModal({
    width: 340,
    icon: null,
    title: (
      <>
        {translate(
          translationKeys.tutoringInstituteProfile.subscriptions.cancelSubscription.confirmation
            .title1
        )}
        <br />
        {translate(
          translationKeys.tutoringInstituteProfile.subscriptions.cancelSubscription.confirmation
            .title2
        )}
      </>
    ),
    buttons: [
      {
        text: translate(
          translationKeys.tutoringInstituteProfile.subscriptions.cancelSubscription.confirmation
            .cancelButton
        ),
        onClick: dialogResultHandlers.onDialogResponseCancel,
        type: 'primary',
      },
      {
        text: translate(
          translationKeys.tutoringInstituteProfile.subscriptions.cancelSubscription.confirmation
            .okButton
        ),
        onClick: dialogResultHandlers.onDialogResponseOK,
      },
    ],
  });
};
